module.exports = __webpack_public_path__ + "static/img/about-c_bg.e7bd208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_bg.png
// module id = Xl8P
// module chunks = 1